import {
  AfterViewInit,
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IEventCard } from '../models/IEventCard';
import * as OpenSeadragon from 'openseadragon';

declare var ImageViewer: any;

@Component({
  selector: 'lib-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss'],
})
export class EventDetailsComponent implements AfterViewInit {
  event: IEventCard;
  eventId: number = 0;
  prevEvent = new EventEmitter<any>();
  nextEvent = new EventEmitter<any>();
  viewer: any;
  slideIndex = 0;
  eventproperties: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<EventDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data.event);
    //set event
    this.event = data.event;
    //set evennt properties
    this.eventproperties = data.event.Properties;
  }

  ngAfterViewInit(): void {
    /* Creating an OpenSeaDragon Dialog. */
    this.viewer = OpenSeadragon({
      id: 'openseadragon',
      prefixUrl: 'https://openseadragon.github.io/openseadragon/images/',
      tileSources: {
        type: 'image',
        url: this.event.Images[this.slideIndex].Path,
      },
      minZoomLevel: 1,
      visibilityRatio: 1.0,
      constrainDuringPan: true,
      maxZoomPixelRatio: 4,
    });

    /* Adding a event to full page button in OpenSeaDragon Dialog. and also set the Z Index */
    this.viewer.fullPageButton.addHandler('click', function () {
      const elem = <HTMLElement>(
        document.querySelector('.openseadragon-container')
      );
      const backButton = <HTMLElement>(
        document.getElementById('openseadragonbackButton')
      );
      if (elem.style.zIndex == '10000') {
        elem.style.zIndex = '0';
        backButton.style.display = 'block';
      } else {
        elem.style.zIndex = '10000';
        backButton.style.display = 'none';
      }
    });

    /* Adding a back button to the OpenSeaDragon Dialog. */
    this.viewer.addOnceHandler('open', () => {
      let backButton = new OpenSeadragon.Button({
        tooltip: 'back',
        srcRest:
          'https://openseadragon.github.io/openseadragon/images/previous_rest.png',
        srcGroup:
          'https://openseadragon.github.io/openseadragon/images/previous_grouphover.png',
        srcHover:
          'https://openseadragon.github.io/openseadragon/images/previous_hover.png',
        srcDown:
          'https://openseadragon.github.io/openseadragon/images/previous_pressed.png',
        onClick: () => {
          this.toggleshowImageContainer();
        },
      });
      this.viewer.addControl(backButton.element, {
        anchor: OpenSeadragon.ControlAnchor.TOP_LEFT,
      });
      backButton.element.id = 'openseadragonbackButton';
    });
  }

  /**
   * The function showPreviousEvent() emits the event object to the parent component
   */
  showPreviousEvent() {
    this.prevEvent.emit(this.event);
  }

  /**
   * The function showNextEvent() is a function that emits the event object to the parent component.
   */
  showNextEvent() {
    this.nextEvent.emit(this.event);
  }

  /**
   * If the slide index is greater than the number of images in the event, set the slide index to 0. If
   * the slide index is less than 0, set the slide index to the number of images in the event.
   * Otherwise, set the slide index to the number passed in.
   * </code>
   * @param {number} n - number - the index of the image to be displayed
   */
  plusSlides(n: number) {
    if (n > this.event.Images.length - 1) {
      this.slideIndex = 0;
    } else if (n < 0) {
      this.slideIndex = this.event.Images.length - 1;
    } else {
      this.slideIndex = n;
    }
    var newImage = {
      type: 'image',
      url: this.event.Images[this.slideIndex].Path,
    };
    this.viewer.open(newImage);
  }

  /**
   *It switches between OpenSeaDragon Dialog and Images Gallery and pass Image path to OpenSeaDragon Dialog.
   * @param {any} [Path] - The path of the image that I want to display in the OpenSeaDragon Dialog.
   */
  toggleshowImageContainer(Path?: any) {
    var x = <HTMLElement>(
      document.getElementsByClassName('slideshow-container')[0]
    );
    var y = <HTMLElement>(
      document.getElementsByClassName('event-details_images_grid-container')[0]
    );
    if (x!.style.display == '' || x!.style.display == 'none') {
      x!.style.display = 'block';
      y!.style.display = 'none';
      var newImage = {
        type: 'image',
        url: Path,
      };
      this.viewer.open(newImage);
      this.slideIndex = this.event.Images.findIndex(x => x.Path == Path);
    } else {
      x!.style.display = 'none';
      y!.style.display = 'grid';
    }
  }
}
